import * as React from "react";

import { SettingsProps } from "../containers";
import { Session } from "../reducers";
import { ReactElement } from "react";

declare const TP_BUILD_DATE: string;

const DeviceInformation = ({ session }: { session: Session }) => {
    if (session.deviceSupport) {
        const rows = Object
            .keys(session.deviceSupport)
            .map((device) => <span key={device}>{device}: {session.deviceSupport[device]}</span>);

        if (rows.length === 0) {
            return <p>DeviceServer online, no readers</p>;
        } else {
            return <p>{rows}</p>;
        }
    } else {
        return <p>DeviceServer offline</p>;
    }
};

export const SettingsInfo = ({ signatures, session, config, offlinestamps }: SettingsProps): ReactElement => {

    const signatureUpdate = signatures.lastUpdate ? signatures.lastUpdate.format("YYYY-MM-DD HH:mm:ss") : null;

    return (
        <div className="info">
            <p>Terminalnamn: {config.terminalName}</p>
            <p>Online: {session.loginTimerId ? "NO" : "YES"} ({offlinestamps} stamps stored)</p>
            <DeviceInformation session={session} />
            <p>Signature count: {signatures.items.length}</p>
            <p>Signature update: {signatureUpdate}</p>
            <p>Server version: {config.serverVersion}</p>
            <p>Client build date: {TP_BUILD_DATE}</p>
        </div>
    );
};
